import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Typography } from '@mui/material'
import setaCima from '../../../Assets/icones/seta-cima.svg'
import setaBaixo from '../../../Assets/icones/seta-baixo.svg'
import ImageCaixaDagua from '../ImageCaixaDagua/ImageCaixaDagua'
import termometro from '../../../Assets/icones/termometro.svg'
import umidade from '../../../Assets/icones/ondasGotas.svg'
import motor from '../../../Assets/icones/motor.svg'

const DisplayCaixaAgua = ({ dados }) => {
    const { nome, nivel, sentido, sts203, sts202, sts101, sts102 } = dados

    return (
        <Grid sx={{ height: '100%', width: '100%' }}>
            <Typography fontSize="26px" fontWeight="600" textAlign="center" color="#590CFB" >{nome}</Typography>
            <Grid container sx={{ display: 'flex', justifyContent: 'space-around', alignContent: 'center', height: '80%' }}>
                <Grid container item direction={'row'} xs={6} sx={{
                    height: '100%'
                }}>
                    <ImageCaixaDagua nivel={nivel} sentido={sentido} />
                    <Grid sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignContent: 'center',
                        alignSelf: 'center',
                        height: '90%',
                        width: '50%'
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignContent: 'center',
                            height: '20%',
                            width: '100%'
                        }}>
                            <img style={{ height: '100%', width: '20%' }} src={termometro}/>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignContent: 'center',
                                height: '100%',
                                width: '80%'
                            }}>
                                <Typography fontSize="15px" fontWeight="600" textAlign="center" >Temperatura</Typography>
                                <Typography fontSize="25px" fontWeight="600" textAlign="center" color="#590CFB" >{sts203}°C</Typography>
                            </div>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignContent: 'center',
                            height: '20%',
                            width: '100%'
                        }}>
                            <img style={{ height: '100%', width: '20%' }} src={umidade}/>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignContent: 'center',
                                height: '100%',
                                width: '80%'
                            }}>
                                <Typography fontSize="15px" fontWeight="600" textAlign="center" >Umidade</Typography>
                                <Typography fontSize="25px" fontWeight="600" textAlign="center" color="#590CFB" >{sts202}%</Typography>
                            </div>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignContent: 'center',
                            height: '20%',
                            width: '100%'
                        }}>
                            <img style={{ height: '100%', width: '20%' }} src={motor}/>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignContent: 'center',
                                height: '100%',
                                width: '80%'
                            }}>
                                <Typography fontSize="15px" fontWeight="600" textAlign="center" >Bomba 1</Typography>
                                <Typography fontSize="25px" fontWeight="600" textAlign="center" color="#590CFB" >{sts101 == 1 ? 'Ligada' : 'Desligada'}</Typography>
                            </div>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignContent: 'center',
                            height: '20%',
                            width: '100%'
                        }}>
                            <img style={{ height: '100%', width: '20%' }} src={motor}/>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignContent: 'center',
                                height: '100%',
                                width: '80%'
                            }}>
                                <Typography fontSize="15px" fontWeight="600" textAlign="center" >Bomba 2</Typography>
                                <Typography fontSize="25px" fontWeight="600" textAlign="center" color="#590CFB" >{sts102 == 1 ? 'Ligada' : 'Desligada'}</Typography>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid item sx={{ height: '100%', flexDirection: 'column', display: 'flex', justifyContent: 'space-around', alignContent: 'center' }}>
                    <Typography fontSize="15px" fontWeight="600" textAlign="center" >Nível</Typography>
                    <Typography fontSize="20px" fontWeight="600" textAlign="center" color="#590CFB" >{nivel}%</Typography>
                    <img style={{ height: '50%' }} src={sentido === 'S' ? setaCima : setaBaixo} />
                    <Typography fontSize="15px" fontWeight="600" textAlign="center" >{sentido === 'S' ? "Enchendo" : "Esvaziando"}</Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default DisplayCaixaAgua

// Dicionário de variáveis para DisplayCaixaAgua:
/*
Sensores
sts201 => Nível da Água (Criado por compatibilidade, o nível da agua usamos o campo: [nivel]
sts202 => Sensor Umidade (ar)
sts203 => Sensor Temperatura
sts204 => Sensor Corrente (amperes)
sts205 => Sensor Potência (watts)
sts206 => Sensor Umidade (solo)
sts207 => Sensor Vibração

Relés:
sts101 => Relé Bomba 1
sts102 => Relé Bomba 2
sts111 => Bomba 1 Ativa
sts112 => Bomba 2 Ativa

Na tela do Plus vamos usar apenas 4 por enquanto:

sts203 -> Temperatura
sts202 -> Umidade
sts101 -> Bomba 1
sts102 -> Bomba 2
*/
